define('areas/navigationmanager/commands/removenavigationnodecommand',["require", "exports"], function (require, exports) {
    "use strict";
    var RemoveNavigationNodeCommand = (function () {
        function RemoveNavigationNodeCommand(process) {
            this._removeNode = process;
        }
        RemoveNavigationNodeCommand.prototype.execute = function (symbol) {
            this._removeNode.process(symbol);
        };
        return RemoveNavigationNodeCommand;
    }());
    return RemoveNavigationNodeCommand;
});

